"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _ContainerRender = _interopRequireDefault(require("rc-util/lib/ContainerRender"));
var _Portal = _interopRequireDefault(require("rc-util/lib/Portal"));
var _switchScrollingEffect = _interopRequireDefault(require("rc-util/lib/switchScrollingEffect"));
var _setStyle = _interopRequireDefault(require("rc-util/lib/setStyle"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-underscore-dangle,react/require-default-props */
var openCount = 0;
var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);
var IS_REACT_16 = 'createPortal' in _reactDom.default;

// https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332
var cacheOverflow = {};
var PortalWrapper = /*#__PURE__*/function (_React$Component) {
  function PortalWrapper(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PortalWrapper);
    _this = _callSuper(this, PortalWrapper, [props]);
    (0, _defineProperty2.default)(_this, "getParent", function () {
      var getContainer = _this.props.getContainer;
      if (getContainer) {
        if (typeof getContainer === 'string') {
          return document.querySelectorAll(getContainer)[0];
        }
        if (typeof getContainer === 'function') {
          return getContainer();
        }
        if ((0, _typeof2.default)(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
          return getContainer;
        }
      }
      return document.body;
    });
    (0, _defineProperty2.default)(_this, "getContainer", function () {
      if (windowIsUndefined) {
        return null;
      }
      if (!_this.container) {
        var parent = _this.getParent();
        if (parent) {
          _this.container = parent.ownerDocument.createElement('div');
          Object.defineProperty(_this.container, 'ownerDocument', {
            value: parent.ownerDocument
          });
          parent.appendChild(_this.container);
        } else {
          _this.container = document.createElement('div');
        }
      }
      _this.setWrapperClassName();
      return _this.container;
    });
    (0, _defineProperty2.default)(_this, "setWrapperClassName", function () {
      var wrapperClassName = _this.props.wrapperClassName;
      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
        _this.container.className = wrapperClassName;
      }
    });
    (0, _defineProperty2.default)(_this, "savePortal", function (c) {
      // Warning: don't rename _component
      // https://github.com/react-component/util/pull/65#discussion_r352407916
      _this._component = c;
    });
    (0, _defineProperty2.default)(_this, "removeCurrentContainer", function (visible) {
      _this.container = null;
      _this._component = null;
      if (!IS_REACT_16) {
        if (visible) {
          _this.renderComponent({
            afterClose: _this.removeContainer,
            onClose: function onClose() {},
            visible: false
          });
        } else {
          _this.removeContainer();
        }
      }
    });
    /**
     * Enhance ./switchScrollingEffect
     * 1. Simulate document body scroll bar with
     * 2. Record body has overflow style and recover when all of PortalWrapper invisible
     * 3. Disable body scroll when PortalWrapper has open
     *
     * @memberof PortalWrapper
     */
    (0, _defineProperty2.default)(_this, "switchScrollingEffect", function () {
      var zIndexControlClassName = 'ykb-ui-overflowing-control';
      var zIndexControlClassNameReg = new RegExp("".concat(zIndexControlClassName), 'g');
      var active_page_content = document.querySelector("#page-tabs .tab-pane.active #page_content");
      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
        (0, _switchScrollingEffect.default)();
        // Must be set after switchScrollingEffect
        cacheOverflow = (0, _setStyle.default)({
          overflow: 'hidden',
          overflowX: 'hidden',
          overflowY: 'hidden'
        });
        if (!zIndexControlClassNameReg.test(document.body.className)) {
          var addClassName = "".concat(document.body.className, " ").concat(zIndexControlClassName);
          document.body.className = addClassName.trim();
          if (active_page_content && active_page_content.style) {
            active_page_content.style.overflow = 'hidden';
            active_page_content.style.overflowX = 'hidden';
            active_page_content.style.overflowY = 'hidden';
          }
        }
      } else if (!openCount) {
        (0, _setStyle.default)(cacheOverflow);
        cacheOverflow = {};
        document.body.className = document.body.className.replace(zIndexControlClassNameReg, '').trim();
        (0, _switchScrollingEffect.default)(true);
        if (active_page_content && active_page_content.style) {
          active_page_content.style.overflow = 'initial';
          active_page_content.style.overflowX = 'hidden';
          active_page_content.style.overflowY = 'auto';
        }
      }
    });
    var _visible = props.visible;
    openCount = _visible ? openCount + 1 : openCount;
    _this.state = {
      _self: _this
    };
    return _this;
  }
  (0, _inherits2.default)(PortalWrapper, _React$Component);
  return (0, _createClass2.default)(PortalWrapper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setWrapperClassName();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var visible = this.props.visible;
      // 离开时不会 render， 导到离开时数值不变，改用 func 。。
      openCount = visible && openCount ? openCount - 1 : openCount;
      this.removeCurrentContainer(visible);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        forceRender = _this$props.forceRender,
        visible = _this$props.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount() {
          return openCount;
        },
        getContainer: this.getContainer,
        switchScrollingEffect: this.switchScrollingEffect
      };
      // suppport react15
      if (!IS_REACT_16) {
        return /*#__PURE__*/_react.default.createElement(_ContainerRender.default, {
          parent: this,
          visible: visible,
          autoDestroy: false,
          getComponent: function getComponent() {
            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return children(_objectSpread(_objectSpread(_objectSpread({}, extra), childProps), {}, {
              ref: _this2.savePortal
            }));
          },
          getContainer: this.getContainer,
          forceRender: forceRender
        }, function (_ref) {
          var renderComponent = _ref.renderComponent,
            removeContainer = _ref.removeContainer;
          _this2.renderComponent = renderComponent;
          _this2.removeContainer = removeContainer;
          return null;
        });
      }
      if (forceRender || visible || this._component) {
        portal = /*#__PURE__*/_react.default.createElement(_Portal.default, {
          getContainer: this.getContainer,
          ref: this.savePortal
        }, children(childProps));
      }
      return portal;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevProps = _ref2.prevProps,
        _self = _ref2._self;
      var visible = props.visible,
        getContainer = props.getContainer;
      if (prevProps) {
        var prevVisible = prevProps.visible,
          prevGetContainer = prevProps.getContainer;
        if (visible !== prevVisible) {
          openCount = visible && !prevVisible ? openCount + 1 : openCount - 1;
        }
        var getContainerIsFunc = typeof getContainer === 'function' && typeof prevGetContainer === 'function';
        if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
          _self.removeCurrentContainer(false);
        }
      }
      return {
        prevProps: props
      };
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(PortalWrapper, "propTypes", {
  wrapperClassName: _propTypes.default.string,
  forceRender: _propTypes.default.bool,
  getContainer: _propTypes.default.any,
  children: _propTypes.default.func,
  visible: _propTypes.default.bool
});
var _default = exports.default = (0, _reactLifecyclesCompat.polyfill)(PortalWrapper);